module.exports = __webpack_public_path__ + "img/6383d15.jpg";